export default "__VITE_ASSET__CQYiHvKT__"